import { render, staticRenderFns } from "./NoteTemplates.vue?vue&type=template&id=548c7a40&scoped=true&"
import script from "./NoteTemplates.vue?vue&type=script&lang=js&"
export * from "./NoteTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c7a40",
  null
  
)

export default component.exports